import moment from "moment/moment";
import {DATE_FORM_FORMAT} from "@/constants/date";

export const defaultFilters = () => ({
  dateFrom: moment().startOf('year').format(DATE_FORM_FORMAT),
  dateTo: moment().format(DATE_FORM_FORMAT),
  advertisers: null,
  countries: null,
  partners: null,
  products: null,
})